module.exports = __webpack_public_path__ + "static/media/ic_user.58c07b6b.png";